export default __webpack_public_path__ + "static/media/logo_digitel.be599954.png";